
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { ArrowLeft } from "lucide-react";

interface CameraDetailsErrorProps {
  error: string | null;
  onBackClick: () => void;
}

export function CameraDetailsError({ error, onBackClick }: CameraDetailsErrorProps) {
  return (
    <div className="container py-6 space-y-6 max-w-[1200px] mx-auto">
      <div className="flex items-center gap-2 mb-6">
        <Button variant="outline" size="sm" onClick={onBackClick}>
          <ArrowLeft className="h-4 w-4 mr-1" />
          Back to Cameras
        </Button>
      </div>
      
      <Card className="border-destructive">
        <CardHeader>
          <CardTitle>Error</CardTitle>
          <CardDescription>Failed to load camera details</CardDescription>
        </CardHeader>
        <CardContent>
          <p>{error || "Camera not found"}</p>
        </CardContent>
      </Card>
    </div>
  );
}
